export const GENDER_COLOR_PINK = "#FFC0CB";
export const GENDER_COLOR_BLUE = "#3944BC";
export const TEXT_COLOR_BLACK = "#000000";
export const TEXT_COLOR_WHITE = "#FFFFFF";
export const ALLERGY_BG_COLOR_RED = "#BC544B";
export const FA_ICON_COLOR = "";
export const FA_ICON_SIZE = "lg";
